import React, {Component} from 'react';

import {UserClientsContent} from "./UserClientsContent";

import {withRouterParams} from "../../utils/withRouterParams";

class UserClients extends Component {
    constructor(props) {
        super(props);
        this.afterSuccessfulAgencyClientSubmit = this.afterSuccessfulAgencyClientSubmit.bind(this);
    }

    redirectToAgencyRegisterPage() {
        this.props.history.push('/agency-register');
    }

    afterSuccessfulAgencyClientSubmit(newAgencyClientId, newAgencyClientName) {
        this.props.history.push(`/client/${newAgencyClientId}/`);
    }

    render() {
        return (
            <UserClientsContent />
        )
    }
}

export default withRouterParams(UserClients);



